import React from "react";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

import {FillerSection} from "../../FillerSection/FillerSection";
import {DeleteButtonTextField} from "../../DeleteButtonTextField/DeleteButtonTextField";


export const DateTimeSelectFiller = ({content, setFieldValue}) => {
    const formats = content?.formats || []

    const handleMaskAdd = () => {
        setFieldValue('content.formats', [...formats, {variable: '', mask: ''}])
    }

    const handleMaskDelete = index => () => {
        setFieldValue('content.formats', formats.filter((_, i) => index !== i))
    }

    const onVariableChange = index => event => {
        setFieldValue('content.formats', formats.map((el, i) => {
            if (index === i) {
                return {...el, variable: event.target.value}
            }
            return el
        }))
    }

    const onMaskChange = index => event => {
        setFieldValue('content.formats', formats.map((el, i) => {
            if (index === i) {
                return {...el, mask: event.target.value}
            }
            return el
        }))
    }

    return <FillerSection title={'Маски'} onAddButtonClick={handleMaskAdd}>
        <Grid container item spacing={2} alignItems={"center"} direction={"column"}>
            {formats.map((el, i) => {
                return <Grid key={`datetime-filler-mask-${i}`} container item spacing={2}>
                    <Grid item xs>
                        <TextField value={el.variable}
                                   onChange={onVariableChange(i)}
                                   label={'Переменная в Word шаблоне'}
                                   fullWidth
                                   variant={"outlined"}
                                   size={"small"}
                        />
                    </Grid>
                    <Grid item xs style={{position: 'relative'}}>
                        <TextField value={el.mask}
                                   onChange={onMaskChange(i)}
                                   label={'Маска'}
                                   fullWidth
                                   variant={"outlined"}
                                   size={"small"}
                        />
                        <DeleteButtonTextField onClick={handleMaskDelete(i)}
                                               style={{
                                                   position: 'absolute',
                                                   zIndex: 'inherit',
                                                   top: 0,
                                                   right: 0
                                               }}

                        />
                    </Grid>
                </Grid>
            })}
        </Grid>
    </FillerSection>
}